import useRebrandVersion from 'hooks/useRebrandVersion'
import type { _BaseButtonVariant } from 'LuxKit/Button/BaseButton'

type LightSurfaceButtonVariant = Extract<_BaseButtonVariant, 'default' | 'dark'>

/**
 * Variant for buttons that draw dark content on a light chrome surface.
 *
 * `variant="dark"` means "dark coloured content" on the legacy palette, but
 * "content for a dark surface" under rebrand, where it resolves to
 * `neutral.surface.staticWhite`. That is the same value as
 * `neutral.surface.normalBackground`, so the control disappears entirely.
 * `default` carries the legacy meaning under rebrand.
 *
 * For controls that sit over imagery or a map, use `useRebrandOverlayButtonKind`
 * instead - those need an opaque fill rather than dark content.
 */
function useRebrandLightSurfaceButtonVariant(): LightSurfaceButtonVariant {
  return useRebrandVersion() === 'rebrand' ? 'default' : 'dark'
}

export default useRebrandLightSurfaceButtonVariant
